var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"instruction"},[_c('BaseText1',{attrs:{"text":_vm.instructionNumber}}),_c('BaseText11',{staticClass:"text-primary",attrs:{"text":_vm.textPrimary}}),_c('BaseText6',{attrs:{"text":_vm.textSecondary}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }